import { createSelector } from '@reduxjs/toolkit';

//📌 Selector access logs
export const selectLockersLogs = createSelector(
	[(state) => state.LockersLogs.data, (state) => state.Auth.selectedProfile.orgID],
	(accessLogs, orgID) => accessLogs[orgID] || []
);

//📌 Selector to get logs by person ID
export const selectLockersLogsByPersonID = createSelector(
	[selectLockersLogs, (state, personID) => personID],
	(logs, personID) => logs.filter((log) => log.personID === personID)
);
